import { Breadcrumb, Space, Typography } from 'antd';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

const { Title } = Typography;

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  breadcrumb?: BreadcrumbItem[];
  actions?: ReactNode;
}

export function PageHeader({ title, description, breadcrumb, actions }: PageHeaderProps) {
  return (
    <div style={{ marginBottom: 24 }}>
      {breadcrumb?.length ? (
        <Breadcrumb
          style={{ marginBottom: 8 }}
          items={breadcrumb.map((b) => ({
            title: b.to ? <Link to={b.to}>{b.label}</Link> : b.label,
          }))}
        />
      ) : null}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
        }}
      >
        <div style={{ minWidth: 0 }}>
          <Title level={3} style={{ margin: 0 }}>
            {title}
          </Title>
          {description ? (
            <div style={{ color: 'var(--ant-color-text-secondary, #595959)', marginTop: 4 }}>
              {description}
            </div>
          ) : null}
        </div>
        {actions ? <Space wrap>{actions}</Space> : null}
      </div>
    </div>
  );
}
